import { render } from "./CreateQuote.vue?vue&type=template&id=a70c500c&ts=true"
import script from "./CreateQuote.vue?vue&type=script&lang=ts"
export * from "./CreateQuote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__